function scrollTo(el) {
	var $el = $(el);
	if ($el.length) {
		var page = $('html, body'),
			offset = 67;

		if (breakpointSm) {
			offset = 59;
		} else if (breakpointXs) {
			offset = 62;
		}

		// Stop auto-scroll if user scroll
		page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function() { page.stop() });

		// Auto-scroll
		page.stop(true, true).animate({
			scrollTop: $el.offset().top - offset - 15
		}, 400, function() {
			page.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
		});

		return false;
	}
}

$(document).ready(function() {
	$('[data-scroll-to]').click(function(){
		scrollTo($(this).data('scroll-to'));
	});
});